import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import FieldMappingApi from '../generated/api/FieldMapping';

export default (service: Servicelayer) => ({
  ...FieldMappingApi(service),

  // Add custom calls here

});
